import './Footer.scss';
import {Link} from "@material-ui/core";
import {IconBrandDiscord, IconBrandGithub, IconBrandLinkedin} from "@tabler/icons-react";
import {Divider} from "@mui/material";

export default function Footer(){

    return (
      <div className={"footer"}>
          <div class={"content"}>
              <div className={"content-profil"}>
                  <img src={"assets/lesty-icon.png"} alt={"logo"} className={"logo"}/>
                  <div className={"title-user"}>
                      <h1>Pierre BIHANNIC</h1>
                      <h4>Lesty - Discord</h4>
                  </div>
              </div>

              <div className={"content-navigation"}>
                  <Link href={"#intro"}>A propos</Link>
                  <Link href={"#skills"}>Compétences</Link>
                  <Link href={"#projects"}>Projets</Link>
                  <Link href={"#contact"}>Contact</Link>
              </div>
          </div>
          <Divider />
          <div className={"content"}>
              <p>© 2023 Lesty. Tous droits réservés.</p>
              <div className={"social"}>
                  <Link href={"https://discord.com/invite/ywmYrQ9Bbm"} target={"_blank"}><IconBrandDiscord /></Link>
                  <Link href={"https://www.linkedin.com/in/pierre-bihannic-77233720a/"} target={"_blank"}><IconBrandLinkedin /></Link>
                  <Link href={"https://github.com/PierreBH"} target={"_blank"}><IconBrandGithub /></Link>
              </div>


          </div>
      </div>
    );
}